export default class CheckoutProApiDriveService {
  path = "/api/magasins";

  constructor(httpApi) {
    this.httpApi = httpApi;
  }

  /**
   * Création d'un checkout pro pour un panier de référence
   * @param {Number} magId
   * @param {String} uuid
   * @param {String} dateLastUpdate
   */
  async create(magId, uuid, dateLastUpdate) {
    const params = { uuid, dateLastUpdate };
    const config = { ...this.httpApi.getConfig(), params };
    const res = await this.httpApi.post(`${this.getPath(magId)}`, null, config);
    return res.data;
  }

  /**
   * Création d'une commande depuis un checkout pro
   * @param {Number} magId
   * @param {String} checkoutId
   * @param {String} uuid
   * @param {String} dateLastUpdate
   */
  async processCreateCommande(magId, checkoutId, uuid, dateLastUpdate, form) {
    const params = { uuid, dateLastUpdate };
    const config = { ...this.httpApi.getConfig(), params };
    const res = await this.httpApi.post(`${this.getPath(magId)}/${checkoutId}/processCreateCommande`, form, config);

    return res.data;
  }

  getPath(magId) {
    return `${this.path}/${magId}/checkoutPro`;
  }
}
